var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8875 2.89078H12.2397V1.32431L1.3125 3.01087V17.7942L12.2397 19.6763V17.3545H18.8875C19.0889 17.3647 19.286 17.2948 19.436 17.16C19.5859 17.0252 19.6763 16.8366 19.6875 16.6353V3.60937C19.6761 3.40821 19.5856 3.21971 19.4357 3.08507C19.2858 2.95042 19.0888 2.88058 18.8875 2.89078ZM18.9925 16.7547H12.2174L12.2063 15.5151H13.8383V14.0713H12.1938L12.1859 13.2182H13.8383V11.7744H12.1734L12.1656 10.9213H13.8383V9.47756H12.1603V8.62444H13.8383V7.18069H12.1603V6.32756H13.8383V4.88381H12.1603V3.57131H18.9925V16.7547Z",
    fill: "#20744A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7572 4.88185H17.5942V6.3256H14.7572V4.88185Z",
    fill: "#20744A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7572 7.17937H17.5942V8.62312H14.7572V7.17937Z",
    fill: "#20744A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7572 9.4769H17.5942V10.9206H14.7572V9.4769Z",
    fill: "#20744A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7572 11.7744H17.5942V13.2182H14.7572V11.7744Z",
    fill: "#20744A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7572 14.072H17.5942V15.5157H14.7572V14.072Z",
    fill: "#20744A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16518 7.00415L5.5735 6.92343L6.45878 9.35747L7.50484 6.82303L8.91315 6.74231L7.20296 10.1981L8.91315 13.6625L7.42412 13.5621L6.41875 10.9213L5.41271 13.4617L4.04443 13.3409L5.63387 10.2808L4.16518 7.00415Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excel-icon.720884ee36e035373cb7464936980244.svg";
export { ForwardRef as ReactComponent };